import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translator } from 'mage-i18n'
import momentPropTypes from 'react-moment-proptypes'
import { DateRangePicker as DateRangePickerReactDates } from 'react-dates'
import {
  ActionIconArrowRight,
  ActionIconChevronLeft,
  ActionIconChevronRight,
  ActionIconClose,
  ButtonSecondary,
  TitleDefinition,
  constants
} from 'mage-deps/@klarna/bubble-ui'
import View from './View'
const { Colors } = constants

const styles = {
  base: {
    borderStyle: 'solid',
    borderColor: Colors.DIVIDER_STRONG,
    borderBottomWidth: 1
  },
  title: {
    transform: 'translateY(8px)'
  },
  presets: {
    flexDirection: 'row',
    padding: '0 20px 20px',
    marginLeft: -5,
    marginRight: -5
  },
  preset: {
    marginLeft: 5,
    marginRight: 5
  }
}

export class DateRangePicker extends React.Component {
  renderPresets (presets) {
    if (!presets.length) return null

    const { onDatesChange } = this.props

    return (
      <View style={styles.presets}>
        {presets.map((p, i) => (
          <View key={i} style={styles.preset}>
            <ButtonSecondary
              size='small'
              onClick={() => onDatesChange({
                startDate: p.start,
                endDate: p.end
              })}
            >
              {p.text}
            </ButtonSecondary>
          </View>
        ))}
      </View>
    )
  }

  render () {
    const { t, label, presets, ...props } = this.props
    return (
      <View style={styles.base}>
        <View style={styles.title}>
          <TitleDefinition>{label}</TitleDefinition>
        </View>
        <DateRangePickerReactDates
          startDatePlaceholderText={t('core.dateRangePicker.startLabel')}
          endDatePlaceholderText={t('core.dateRangePicker.endLabel')}
          hideKeyboardShortcutsPanel
          noBorder
          firstDayOfWeek={1}
          navPrev={<ActionIconChevronLeft color='pink' />}
          navNext={<ActionIconChevronRight color='pink' />}
          customArrowIcon={<ActionIconArrowRight />}
          customCloseIcon={<ActionIconClose />}
          renderCalendarInfo={() => this.renderPresets(presets)}
          {...props}
        />
      </View>
    )
  }
}

DateRangePicker.defaultProps = {
  styles: {},
  startDate: null,
  endDate: null,
  label: '',
  displayFormat: 'll',
  showClearDates: true,
  minimumNights: 0,
  keepOpenOnDateSelect: false,
  presets: []
}

DateRangePicker.propTypes = {
  startDate: momentPropTypes.momentObj,
  endDate: momentPropTypes.momentObj,
  onDatesChange: PropTypes.func.isRequired,
  onFocusChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  presets: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    start: momentPropTypes.momentObj,
    end: momentPropTypes.momentObj
  })),
  t: PropTypes.func
}

export default connect(
  state => ({ t: translator(state) })
)(DateRangePicker)
